const AWS_Config = {
  Auth: {
    identityPoolId: "us-west-2:96dd89c9-6972-4ff7-a2b2-9f5f095a937a",
    region: "us-west-2",
  },
};

export default AWS_Config;
